import { AccountRoleEnum } from '../services/SessionService';

export enum DiagnosisState {
  IDLE = 'IDLE',
  PROCESSING = 'PROCESSING',
  REQUIRES_ASSESSMENT = 'REQUIRES_ASSESSMENT',
  ASSESSED = 'ASSESSED',
  REVOCABLE = 'REVOCABLE',
}

export interface DiagnosisStateContext {
  role: AccountRoleEnum | null;
  isGenerating: boolean;
  isReportGenerated: boolean;
  assessmentRequired: boolean;
}

export function getDiagnosisState(context: DiagnosisStateContext): DiagnosisState {
  if (context.isGenerating) {
    return DiagnosisState.PROCESSING;
  }

  if (!context.isReportGenerated) {
    return DiagnosisState.IDLE;
  }

  if (context.role === AccountRoleEnum.ENVIRONMENT_ADMIN) {
    return DiagnosisState.REVOCABLE;
  }

  if (context.assessmentRequired) {
    return DiagnosisState.REQUIRES_ASSESSMENT;
  }

  return DiagnosisState.ASSESSED;
}
